import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';

import { SearchableDropdownField } from 'ui-components/components/dropdown';
import { INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';

import styles from './csv-column-searchable-dropdown.module.css';
import { messages } from './messages';

/**
 * @typedef {object} CSVColumnOption
 * @property {string} text
 * @property {string} value
 * @property {boolean} [isDefault]
 * @property {import('@fortawesome/fontawesome-common-types').IconDefinition} [icon]
 */

/**
 * @param {CSVColumnOption} option
 * @returns {string}
 */
const getOptionLabel = (option) => option.text;

/**
 * @param {CSVColumnOption} option
 * @returns {React.ReactNode}
 */
const renderOption = (option) => {
  const { icon } = option;
  const optionLabel = getOptionLabel(option);

  return (
    <>
      {icon ? <FontAwesomeIcon className={styles['option-icon']} icon={icon} /> : null}
      {optionLabel}
    </>
  );
};

/**
 * @param {object} props
 * @param {React.ReactNode} props.inlineMessage
 * @param {(option: string) => void} props.onOptionSelected
 * @param {CSVColumnOption[]} props.options
 * @param {string} props.selectedOptionValue
 * @returns {JSX.Element}
 */
export const CsvColumnSearchableDropdown = ({ inlineMessage, onOptionSelected, options, selectedOptionValue }) => {
  const intl = useIntl();

  return (
    <SearchableDropdownField
      getOptionLabel={getOptionLabel}
      inlineMessage={inlineMessage}
      inlineMessageType={INLINE_MESSAGE_TYPES.error}
      onItemSelected={onOptionSelected}
      options={options}
      placeholder={intl.formatMessage(messages.doNotImport)}
      renderOption={renderOption}
      renderSelectedValue={getOptionLabel}
      selectedItemValue={selectedOptionValue}
    />
  );
};
